















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { InventoryEventTypeEnum } from '@/api/types';
import { search_agency_sales_reports } from '@/api/salesreport';
import {
  stringFromIDate,
  translateComponentResource,
  monthStringFromIDate,
} from '@/utils/index';
import { IDate } from '@/api/types';
import { AppRoleType } from '@/utils/types';

@Component({
  name: 'SalesReportListResult',
})
export default class extends Vue {
  @Prop({ required: true })
  reports!: search_agency_sales_reports.ReportSummary[];
  private loading = false;
  private filterText = '';

  get translatedEventHeaders() {
    return [
      { text: this.$t('Id'), value: 'id' },
      { text: this.$t('Target month'), value: 'targetMonth' },
      { text: this.$t('Consignment sales'), value: 'agentName' },
      { text: this.$t('Operations'), value: 'operations' },
    ];
  }

  get canEdit() {
    return UserModule.roles.some(
      r =>
        (r as AppRoleType) === AppRoleType.ADMIN ||
        (r as AppRoleType) === AppRoleType.SUPPLIER
    );
  }

  private getTargetMonthText(month: IDate) {
    return monthStringFromIDate(month);
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }
}
